import React from 'react';
import { compose } from 'redux';
import { FormattedMessage } from 'translations';
import { reduxForm, Field } from 'redux-form';
import { connectSubpages } from 'app/hocs/subpageManagable';
import MobileAutocomplete from 'app/components/base/BaseAutocomplete/Mobile';
import MobileScreen from 'app/components/base/MobileScreen';
import {
  BOOK_TRIP_FORM,
  AUTOCOMPLETE_TYPES
} from 'app/constants';


const messages = {
  cancel: { id: 'CANCEL' },
  title: { id: 'BOOK_TRIP.CRUISE.TITLE' },
  cruisePlaceholder: { id: 'BOOK_TRIP.CRUISE.PLACEHOLDER' }
};

export class CruiseSelectorScreen extends React.Component {

  handleSelect = () => {
    const { subpages } = this.props;
    subpages.popPage();
  }

  render() {
    const { fieldName } = this.props;
    return (
      <MobileScreen
        title={<FormattedMessage {...messages.title} />}
        titleDone={<FormattedMessage {...messages.cancel} />}
        onClickDone={this.handleSelect}
      >
        <Field
          name={fieldName}
          id={fieldName}
          component={MobileAutocomplete}
          target={AUTOCOMPLETE_TYPES.CRUISE}
          onSelect={this.handleSelect}
          placeholder={<FormattedMessage {...messages.cruisePlaceholder} />}
          unsafe
        />
      </MobileScreen>
    );
  }
}

// TODO: move to Flow types
// CruiseSelectorScreen.propTypes = {
//   subpages: PropTypes.object.isRequired,
//   fieldName: PropTypes.string,
// };

// Configure form for the autocomplete screen
const formConfig = {
  form: BOOK_TRIP_FORM,
  destroyOnUnmount: false
};

export default compose(
  reduxForm(formConfig),
  connectSubpages()
)(CruiseSelectorScreen);
